import styled from 'styled-components';

import { FiChevronDown } from 'react-icons/fi';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ItemsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SelectLabel = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #3d3d3d;
`;

export const TotalLabel = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #3d3d3d;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const PaginationLabel = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #3d3d3d;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Button = styled.button`
  outline: none;
  all: unset;
  background: #ffffff;
  border: 1px solid #e1e2e4;
  width: 44px;
  height: 44px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const SelectWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: fit-content;
`;

export const StyledSelect = styled.select`
  outline: none;
  appearance: none;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 8px 36px 8px 12px;
  font-size: 16px;
  color: #333;
  cursor: pointer;

  &:focus {
    border-color: #007bff;
    outline: none;
  }
`;

export const ChevronIcon = styled(FiChevronDown)`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  pointer-events: none;
  color: #b3b3b3;
`;
